import { useMemo, useState } from "react";
import {
  List,
  TextField,
  WrapperField,
  DatagridConfigurable,
  WithRecord,
  BooleanField,
  BulkDeleteWithConfirmButton,
  useResourceContext,
  useTheme,
  usePermissions,
  DateField,
} from "react-admin";
import CloseIcon from "@mui/icons-material/Close";
import EditBtn from "../../components/editBtn/EditBtn";
import ConfirmBtn from "../../components/confirmBtn/ConfirmBtn";
import DoneIcon from "@mui/icons-material/Done";
import PrintBtn from "../../components/printBtn/PrintBtn";
import PrintHandler from "../../components/printHandler/PrintHandler";
import restockPlanFilterList from "../../components/restockPlans/filter/restockPlanFilterList";
import RestockPlanAddDialog from "../../components/restockPlans/create/RestockPlanAddDialog";
import RestockPlanEditDialog from "../../components/restockPlans/edit/RestockPlanEditDialog";
import PrintContent from "../../components/restockPlans/print/PrintContent";
import RestockPlanExpandList from "../../components/restockPlans/expand/RestockPlanExpandList";
import ExcelButton from "../../components/exportButtons/ExcelButton";
import TableListActions from "../../components/tableListActions/TableListActions";

const RestockPlanList = (props) => {
  const resource = useResourceContext();
  const { permissions } = usePermissions();
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [recordId, setRecordId] = useState();
  const [showAside, setShowAside] = useState(false);
  const [resetPrintContent, setResetPrintContent] = useState();
  const [printRecord, setPrintRecord] = useState({}); // initial value wajib object kosong untuk cek key id di dependency useeffect DeliveryNote.js
  const [theme] = useTheme("light");

  const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };
  const handleClickOpenEdit = (recId) => () => {
    setRecordId(recId);
    setOpenEdit(true);
  };
  const rowClickHandler = (id, basePath, record) => {
    return "expand";
  };

  const list = useMemo(() => {
    return (
      <List
        title={props.title ? props.title : undefined}
        empty={false}
        actions={
          <TableListActions
            createHandler={handleClickOpenAdd}
            exporter={false}
            createPermission="create_restock_plan"
          />
        }
        filters={restockPlanFilterList(permissions)}
        queryOptions={{ meta: { sort: ["code DESC"] } }} // overide default sort
      >
        <DatagridConfigurable
          bulkActionButtons={<BulkDeleteWithConfirmButton />}
          rowClick={rowClickHandler}
          expand={<RestockPlanExpandList />}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          {permissions && permissions.update_company ? (
            <TextField label="mine.label.company" source="company.alias" />
          ) : null}
          <TextField source="code" label="mine.label.code" />
          <TextField
            source="month"
            label="mine.label.month"
            textAlign="center"
          />
          <TextField source="year" label="mine.label.year" textAlign="center" />
          <DateField
            source="cut_off_date"
            label="mine.label.cut_off_date"
            textAlign="center"
            options={{
              year: "numeric",
              month: "short",
              day: "2-digit",
            }}
          />
          <BooleanField
            source="approved"
            label="mine.label.approved"
            textAlign="center"
          />
          <WrapperField key={2} label="mine.label.actions" textAlign="center">
            <WithRecord
              render={(record) => {
                return !record.approved ? (
                  <>
                    <EditBtn
                      editHandler={handleClickOpenEdit(record.id)}
                      sx={{ mr: 1 }}
                    />
                    <ConfirmBtn
                      title="mine.message.approve"
                      content="mine.message.approve_content"
                      label="mine.btn.approve"
                      resource={resource + "/approve"}
                      startIcon={<DoneIcon />}
                    />
                  </>
                ) : (
                  <>
                    <PrintBtn
                      dialogProps={{ title: "mine.dialog.print" }}
                      recordId={record.id}
                      setPrintRecord={setPrintRecord}
                      setResetPrintContent={setResetPrintContent}
                      tool
                    />
                    <ExcelButton
                      dialogProps={{ title: "Excel" }}
                      recordId={record.id}
                    />
                    {permissions.administrator ? (
                      <ConfirmBtn
                        title="mine.message.unapprove"
                        content="mine.message.unapprove_content"
                        label="mine.label.unapprove"
                        resource={resource + "/unapprove"}
                        startIcon={<CloseIcon />}
                        color="error"
                      />
                    ) : null}
                  </>
                );
              }}
            />
          </WrapperField>
          ,
        </DatagridConfigurable>
      </List>
    );
  }, [showAside, theme, permissions]);
  return (
    <>
      {list}
      <RestockPlanAddDialog open={openAdd} setOpen={setOpenAdd} />
      <RestockPlanEditDialog
        open={openEdit}
        setOpen={setOpenEdit}
        recordId={recordId}
      />
      <PrintHandler
        record={printRecord}
        resetPrintContent={resetPrintContent}
        Content={PrintContent}
      />
    </>
  );
};

export default RestockPlanList;
